// @flow

import React from "react";
import classNames from "classnames";
import { TooltipDropdown } from "@components";

export type StatTileProps = $Exact<{
  title: string,
  value: string,
  className?: string,
  footerClassName?: string,
  prefix?: string,
  description?: string,
  onClick?: () => void,
  tooltip: Object,
}>;

const StatTile = ({
  title,
  value,
  className,
  footerClassName,
  prefix,
  description,
  onClick,
  tooltip,
}: StatTileProps) => {
  const tile = (
    <div
      onClick={onClick}
      className={classNames("stat-tile", className, {
        "with-hover": onClick,
      })}
    >
      <div className="content">
        <p className="m-0">
          {value}
          {prefix && <span className="fs-20">{prefix}</span>}
        </p>
      </div>
      <div className={classNames("footer", footerClassName)}>{title}</div>
    </div>
  );

  return tooltip ? (
    <TooltipDropdown
      description={tooltip.description}
      title={tooltip.title || title}
      id={tooltip.id}
    >
      {tile}
    </TooltipDropdown>
  ) : (
    tile
  );
};

export default StatTile;
